class CalculatorMeasurementPresets extends HTMLElement {
    constructor() {
        super();

        this.measurementPresetSelector = this.querySelector('[data-measurement-presets-selector]');
        this.measurementPresetGroup = this.querySelector('[data-measurement-preset-group]');
        this.measurementInputGroup = this.querySelector('[data-measurement-input-group]');

        this.railInput = this.measurementInputGroup?.querySelector('input[name="properties[Rail Length (cm)]"]');
        this.dropInput = this.measurementInputGroup?.querySelector('input[name="properties[Drop (cm)]"]');
        this.widthInput = this.measurementInputGroup?.querySelector('input[name="properties[Width (cm)]"]');
    }
    
    connectedCallback() {
        setTimeout(() => {
            this.initialInputPresetDefaults();
        }, 750);
        
        this.controlPresetSelections();

        this.addEventListener('click', (event) => {
            this.controlPresetSelections(event);
        });

        this.measurementPresetGroup?.addEventListener('click', (event) => {
            this.selectPreset(event);
        });

        // Sync preset state before document bubble listeners (e.g. .calc-prop → queueMicrotask(calculatePrice))
        this.measurementPresetGroup?.addEventListener('change', (event) => {
                if (event.target.tagName !== 'SELECT') return;
                if (!event.target.closest('[data-measurement-preset-group]')) return;
                
                document.dispatchEvent(
                    new CustomEvent('measurementPresetSelected', {
                        detail: { measurementPreset: event.target.value },
                    })
                );
            },
            true
        );
    }

    controlPresetSelections(event) {
        if (!this.measurementPresetSelector) return;

        if (event) {
            if (event.target.checked && event.target.value === 'Presets') {
                this.showPresets();
                this.selectPreset(event, this.measurementPresetGroup.querySelector('select').value);
            } 
            if (!event.target.checked && event.target.value == 'Presets') {
                this.hidePresets();
            }
        } else {
            if (this.measurementPresetSelector.querySelector('input[type="checkbox"]').checked) {
                this.showPresets();
                const presetSelect = this.measurementPresetGroup?.querySelector('select');

                if (presetSelect) {
                    this.selectPreset(null, presetSelect.value);
                }
            } 
            if (!this.measurementPresetSelector.querySelector('input[type="checkbox"]').checked) {
                this.hidePresets();
            }
        }
    }

    showPresets() {
        this.measurementPresetGroup?.classList.add('active');
        this.measurementInputGroup?.classList.remove('active');
    }

    hidePresets() {
        this.measurementPresetGroup?.classList.remove('active');
        this.measurementInputGroup?.classList.add('active');
        this.setInputPresetDefaults();
        document.dispatchEvent(new CustomEvent('measurementPresetCleared'));
    }

    selectPreset(event, selectedPreset) {
        if (event && event.target.tagName === 'SELECT' && event.target.closest('[data-measurement-preset-group]')) {
            return;
        }

        document.dispatchEvent(
            new CustomEvent('measurementPresetSelected', {
                detail: { measurementPreset: selectedPreset },
            })
        );
    }

    initialInputPresetDefaults() {
        if (this.railInput) this.railInput.setAttribute('data-default-value', this.railInput.value);
        if (this.dropInput) this.dropInput.setAttribute('data-default-value', this.dropInput.value);
        if (this.widthInput) this.widthInput.setAttribute('data-default-value', this.widthInput.value);
    }

    setInputPresetDefaults() {
        const toDispatch = [];

        if (this.railInput) {
            this.railInput.value = this.railInput.getAttribute('data-default-value');
            toDispatch.push(this.railInput);
        }

        if (this.dropInput) {
            this.dropInput.value = this.dropInput.getAttribute('data-default-value');
            toDispatch.push(this.dropInput);
        }

        if (this.widthInput) {
            this.widthInput.value = this.widthInput.getAttribute('data-default-value');
            toDispatch.push(this.widthInput);
        }

        toDispatch.forEach(function (el) {
            el.dispatchEvent(new Event('change', { bubbles: true }));
        });
    }
}

customElements.define('calculator-measurement-presets', CalculatorMeasurementPresets);